import React,{useState, useContext,useRef,useEffect } from 'react';
import AuthContext from './../../context/AuthContext';
import './analytics.css';
import { useNavigate } from "react-router-dom";
import Navbar from './../../components/navbar/navbar';
import ReactEChart from 'echarts-for-react';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { collection, getDocs, doc, addDoc, query, where } from "firebase/firestore";
import {auth,db} from './../../firebaseconfig.js'
import { async } from '@firebase/util';
import Logs from './../../components/logs/logs';
import LogRecord from './../../components/logs/logrecord';



const valueByStringPath = (obj, keys) => {
  let result = []
  for(var k = 0; k<keys.length; k++){
    let key = keys[k].split(".")
    let obj_copy = obj
    for(var i = 0; i<key.length;i++) {
      obj_copy = obj_copy[key[i]]
    }
    result.push(obj_copy)
  }
  
  return result.join("-")
}

const sortObject = obj => Object.keys(obj).sort().reduce((res, key) => (res[key] = obj[key], res), {});

const groupBySum = (list,key) => {
  let sumObj = {}
  for(var i=0; i<list.length; i++){
      let obj = list[i]
      let obj_key_value = valueByStringPath(obj,key)
      if (sumObj[obj_key_value]){
          sumObj[obj_key_value] +=  obj.expense
      } else {
          sumObj[obj_key_value] =  obj.expense
      }
  }
  let sortedSumObj = sortObject(sumObj)
  return sortedSumObj
}

const getXY = (obj) => {
  return [Object.keys(obj),Object.values(obj)]
}


const Dropdown = ({options,inputRef,filterDisplayHandler}) => {

  const selectFilter = (e,val) => {
    e.stopPropagation()
    inputRef.current.value = val;
    filterDisplayHandler("")
  }


  console.log(options);
  return (
    <div className="dropdown_options_container">
      {options.map((ins) => {
        return (
          <div className="dropdown_options" onClick={(e) => selectFilter(e,ins[0])}>
            <span>{ins[0]}</span>
          </div>
        )
      })}
    </div>
  )

}

const Analytics = () => {

  const filter1Ref = useRef()
  const filter2Ref = useRef()
  const filter3Ref = useRef()

  let chartBaseSetting = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    dataZoom: [
      {
        type: 'slider',
        xAxisIndex: 0,
        height: 20,
        bottom: 0,
        start: 0,
        end: 45,
        handleSize: '80%',
        showDetail: false
      },
      {
        type: 'inside',
        id: 'insideX',
        xAxisIndex: 0,
        start: 0,
        end: 45,
        zoomOnMouseWheel: false,
        moveOnMouseMove: true
      }
    ],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: { interval: 0, rotate: 0, fontSize:8 }
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        type: 'bar',
        barWidth: 40,
        barGap: 20,
        label: {
          show: true,
          position: 'inside',
          fontSize: 8,
        },
        itemStyle:{
          borderRadius: 5,
          color:"#90659A",
        },
        data: []
      }
    ]
  }

  let {user} = useContext(AuthContext)

  let [allExpenses, setallExpenses] = useState([])
  let [categoryOptions, setcategoryOptions] = useState([])
  const [filterDisplay,setFilterDisplay] = useState("")

  const [chartOptions, setChartOptions] = useState(chartBaseSetting)

  let auth_ctx = useContext(AuthContext)

  let navigate = useNavigate();


  const submitFilterForm = async (e) => {
    e.preventDefault()
    if(filter1Ref.current.value == "" || filter2Ref.current.value == "" || filter3Ref.current.value == "") {
      alert("Selet All Inputs")
      return
    }
    let filter1 = filter1Ref.current.value
    let filter2 = filter2Ref.current.value
    let filter3 = filter3Ref.current.value
    console.log(filter1,filter2,filter3);

    let q = ""
    if(filter1 == "Month") {
      q = query(
        collection(db, "Expenses"),
        where("uid", "==", user.uid),
        where(`date.year`, "==" , filter2.split("-")[0]),
        where(`date.month`, "==" , filter2.split("-")[1]),
      )
    } else if(filter1 == "Date"){
      q = query(
        collection(db, "Expenses"),
        where("uid", "==", user.uid),
        where(`date.year`, "==" , filter2.split("-")[0]),
        where(`date.month`, "==" , filter2.split("-")[1]),
        where(`date.day`, "==" , filter2.split("-")[2]),
      )
    } else if(filter1 == "Category") {
      console.log("Category query");
      q = query(
        collection(db, "Expenses"),
        where("uid", "==", user.uid),
        where("category.label", "==" , filter2),
      )
    }

    const querySnapshot = await getDocs(q);
    let logrecords = []
    querySnapshot.forEach((d) => {
      let data = d.data()
      logrecords.push(data)
    })

    let group_label = []
    console.log(filter3);
    if(filter3 == "By Date"){
      group_label = ["date.day","date.month","date.year"]
    } else if (filter3 == "By Category") {
      group_label = ["category.label"]
    } else if(filter3 == "By Month") {
      group_label = ["date.month"]
    }

    let chartValues = getXY(groupBySum(logrecords,group_label))
    let graph_percent = parseInt((4/chartValues[0].length)*100);
    chartBaseSetting.xAxis[0].data = chartValues[0]
    chartBaseSetting.series[0].data = chartValues[1]
    chartBaseSetting.dataZoom[0].end = graph_percent
    chartBaseSetting.dataZoom[1].end = graph_percent
    setChartOptions(chartBaseSetting)
    setallExpenses(<Logs title="All Expenses" logrecords={logrecords.map((data) => <LogRecord img={data.category.icon} title={data.note} subTitle={data.category.label} value={data.expense} />)} />)
  }

  const openFilterDropdown = (filterType) => {
    setFilterDisplay(filterType)
    if(filterType == "filter1") {
      filter2Ref.current.value = "";
      filter3Ref.current.value = "";
    }
  }

  // Used to reset filter2 and filter3 if flter1 is changed.
  const resetOtherInputs = () => {
    filter2Ref.current.value = "";
    filter3Ref.current.value = "";
  }

  const loadFilter2 = () => {
    if (filter1Ref.current?.value == "Month") {
      return <input type="month" ref={filter2Ref} name="filter2" required />
    } else if (filter1Ref.current?.value == "Date") {
      return <input type="date" ref={filter2Ref} name="filter2" required />
    } else if (filter1Ref.current?.value == "Category") {
      return (
        <React.Fragment>
          <input type="text" ref={filter2Ref} name="filter2" placeholder='Select Category' onChange={submitFilterForm} onClick={() => {openFilterDropdown("filter2")}} readOnly required />
          { (filterDisplay == "filter2") ? <Dropdown options={categoryOptions} inputRef={filter2Ref} filterDisplayHandler={setFilterDisplay} /> : null }
        </React.Fragment>
      )
    }
  }

  const loadfilter3options = () => {
    if (filter1Ref.current.value == 'Month') {
      return [['By Date'],['By Category']]
    } else if (filter1Ref.current.value == 'Date') {
      return [['By Category']]
    } else if (filter1Ref.current.value == 'Category') {
      return [['By Date'],['By Month']]
    }
  }

  const fetchCategoryOptions = async () => {
    const querySnapshot = await getDocs(collection(db, "UserCategory"));
    let alloptions = []
    querySnapshot.forEach((doc) => {
    let data = doc.data()
    alloptions.push([data.name,doc.id])
    //alloptions.push(data.name)
  });
  setcategoryOptions(alloptions)
  }

  useEffect( () =>{
    fetchCategoryOptions()
  },[])



  return (
    <div className='div analytics'>

      <div className="analytics_header">
        <h2>Lets Analyze</h2>
        <p>Select options below to create your analysis prompt.</p>
      </div>

      <form id="analytics_form" onSubmit={submitFilterForm}>

        <div className="analytics_filter_element analytics_main_filter_element" onClick={() => {openFilterDropdown("filter1")}}>
          <input ref={filter1Ref} name="filter1" defaultValue="Month" onChange={submitFilterForm}  readOnly required />
          { (filterDisplay == "filter1") ? <Dropdown options={[['Month'],['Date'],['Category']]} inputRef={filter1Ref} filterDisplayHandler={setFilterDisplay} /> : null }
        </div>
        <div className="analytics_filter_element" style={filter1Ref.current?.value == "Category"? null : {overflow:'hidden'}}>
          {loadFilter2()}
        </div>
        <div className="analytics_filter_element" onClick={() => {openFilterDropdown("filter3")}}>
          <input ref={filter3Ref} name="filter3" placeholder='View by' readOnly onChange={submitFilterForm} required  />
          { (filterDisplay == "filter3") ? <Dropdown options={loadfilter3options()} inputRef={filter3Ref} filterDisplayHandler={setFilterDisplay} /> : null }
        </div>
        <div className="analytics_filter_element analytics_main_filter_element">
          <button type='submit'>Show Analytics</button>
        </div>

      </form>

      <ReactEChart option={chartOptions} />

      <br />
      <br/>
      <div className="analytics_logs_container">
        {allExpenses}
      </div>
      
      <Navbar iconColors={['#B9B9B9','#41224A','#B9B9B9','#B9B9B9']} />
    </div>
  )
}



export default Analytics;
